import { setContractorActiveFilter } from 'store/contractor-active-filter/actions'
import { connect } from 'react-redux'
import Employer from './Employer'

const mapStateToProps = state => ({
  contractorActiveFilter: state.contractorActiveFilter
})

const mapDispatchToProps = dispatch => ({
  setContractorActiveFilter: (filter) => {
    dispatch(setContractorActiveFilter(filter))
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(Employer)



// WEBPACK FOOTER //
// ./src/components/Employer/index.js